import { render, staticRenderFns } from "./Quantities.vue?vue&type=template&id=bd17ab30&"
import script from "./Quantities.vue?vue&type=script&lang=js&"
export * from "./Quantities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports